import React, { useState, useEffect } from "react";
import { toast } from "../../utils/appToast";

// import "./filterModal";
import axios from "axios";
// import "./FilterModalForFolder.css"
import Cookies from "js-cookie";
import api from "../chat/api";
const FilterModalForFolder = ({ isOpen, onClose, onApply, setFiles,  onClear, folderId, src ,setIsFilterApplied,selectedFilters,setSelectedFilters}) => {
  const [token, setToken] = useState("");
  // const [selectedFilters, setSelectedFilters] = useState({
  //   normalDocument: false,
  //   contract: false,
  //   invoice: false,
  //   spreadsheet: false,
  // });
  const [fileType, setFileType] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rangeDate, setRangeDate] = useState("");



  

  const [activeTab, setActiveTab] = useState("FileType");

const handleApply = async () => {
  const fileTypeMapping = {
    passport: "Passport",
    id: "ID",
    visa: "Visa",
    license: "License",
  };

  const selectedFileTypes = Object.keys(selectedFilters)
    .filter((key) => selectedFilters[key])
    .map((key) => fileTypeMapping[key])
    .filter(Boolean);  // ✅ critical to remove undefined

  if (selectedFileTypes.length === 0) {
    alert("Please select at least one file type.");
    return;
  }

  const params = {
    file_type: selectedFileTypes.join(","),  // ✅ clean, no trailing comma
  };


  try {
    const response = await api.get(`api/v1/idsocr/filter-id/`, { params });

    if (response.status === 200) {
      setIsFilterApplied(true);
      onApply(response.data);  // should be: { documents: [...] }
    }
  } catch (err) {
    if (err.response?.data?.msg) {
  toast.error(err.response.data.msg);
} else {
  toast.error("An error occurred while applying the filter.");
}

  }

  onClose();
};



  const handleCheckboxChange = (type) => {
    setSelectedFilters((prev) => {
      const updatedFilters = { ...prev, [type]: !prev[type] };

      setFileType(() => {
      const fileTypeMapping = {
  passport: "Passport",
  id: "ID",
  visa: "Visa",
  license: "License",
};


      const selectedFileTypes = Object.keys(updatedFilters)
        .filter((key) => updatedFilters[key])  // ✅ filter true values
        .map((key) => fileTypeMapping[key]);   // ✅ map to correct label

      return selectedFileTypes;
    });

      return updatedFilters;
    });
  };

const clearAllFilters = async () => {
  try {
    setSelectedFilters({
      passport: false,
      id: false,
      visa: false,
      license: false,
    });

    const response = await api.get(`api/v1/idsocr/ids/`);

  if (response.status === 200) {
      onApply({ documents: response.data }); // ✅ still needed
      setIsFilterApplied(false); // ✅ local update
      // ✅ inform parent via optional onClear prop
      if (typeof onClear === 'function') {
        onClear({ documents: response.data });
      }
    }
  } catch (error) {
    console.error("Error clearing filters:", error);
  } finally {
    onClose();
  }
};


  
  

  const isDatePickerDisabled = rangeDate !== "";

  if (!isOpen) return null;

  return (
<div
  className="fixed inset-0 z-50 bg-black/40"
  style={{ backdropFilter: 'blur(1.5px)' }}
>
  <div
    className="absolute top-[17%] left-[50%] transform -translate-x-[60%] w-[288px] h-[293px] bg-[#FEF9F7] border border-[rgba(0,0,0,0.1)] rounded-b-xl rounded-tr-xl p-5 shadow-lg"
  >
    <button
      className="absolute top-[3px] right-[10px] text-[#52525B] text-[24px] font-bold hover:text-[#C95EBE] transition-colors duration-300"
      onClick={onClose}
    >
      &times;
    </button>
        <h2>Filter Files</h2>
        <div className="Display">
          {/* <div className="Box-rec">
            <button
              className={`Box-doc ${activeTab === "FileType" ? "active-tab" : ""}`}
              onClick={() => setActiveTab("FileType")}
            >
              <img src="./File-type.svg" alt="" />
              File Type
            </button>
          </div> */}

          {activeTab === "FileType" && (
            <div className="filter-options">
              <div className="Header-doc-filter-folders">
 <p>Select the type of files to include in the results </p>              </div>
            <label>
  <input
    type="checkbox"
    checked={selectedFilters.passport}
    onChange={() => handleCheckboxChange("passport")}
    className="chekcbox-doc-filter"
  />
  Passport
</label>

<label>
  <input
    type="checkbox"
    checked={selectedFilters.id}
    onChange={() => handleCheckboxChange("id")}
    className="chekcbox-doc-filter"
  />
  ID
</label>

<label>
  <input
    type="checkbox"
    checked={selectedFilters.visa}
    onChange={() => handleCheckboxChange("visa")}
    className="chekcbox-doc-filter"
  />
  Visa
</label>

<label>
  <input
    type="checkbox"
    checked={selectedFilters.license}
    onChange={() => handleCheckboxChange("license")}
    className="chekcbox-doc-filter"
  />
  License
</label>


            </div>
          )}
        </div>

        <div className="filter-actions-folder">
          <button onClick={clearAllFilters} className="filter-actions-folder-button">
            Clear All
          </button>
          <button onClick={handleApply} className="filter-actions-folder-buttons">
            Apply filter
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterModalForFolder;